function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import classNames from 'classnames';
import { Icon } from "./..";
import React, { useEffect, useState } from 'react';
import "./AlertItem.less";
var AlertItem = function AlertItem(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAlert = _useState2[0],
    setShowAlert = _useState2[1]; //是否显示alert
  var icon = props.icon,
    iconProperty = props.iconProperty,
    type = props.type,
    content = props.content,
    isToast = props.isToast,
    error = props.error,
    className = props.className,
    style = props.style,
    period = props.period,
    onRemove = props.onRemove;
  var periodVal = period !== null && period !== void 0 ? period : 3;
  useEffect(function () {
    setShowAlert(true);
    var time = null;
    if (periodVal) {
      var num = periodVal * 1000;
      time = setTimeout(function () {
        //通知父组件移除自身
        if (onRemove) {
          onRemove();
        }
      }, num);
    }
    //清除計時器
    return function () {
      if (time) {
        clearTimeout(time);
      }
    };
  }, [periodVal]);

  //獲取外層元素的classname
  var getContainerClassName = function getContainerClassName(error, isToast, className) {
    var defaultClass = 'iron-alert iron-alert-flex';
    //是否有自定义classname
    if (className) {
      defaultClass = classNames(defaultClass, className);
    }

    //是否err
    if (error) {
      var errClass = 'iron-alert-err';
      defaultClass = classNames(defaultClass, errClass);
    }

    //是否有關閉按鈕
    if (isToast) {
      var hasCloseIconClass = 'iron-alert-has-close';
      defaultClass = classNames(defaultClass, hasCloseIconClass);
    }
    return defaultClass;
  };

  //根据图标类型，渲染对应图标
  var renderIcon = function renderIcon(type, iconProperty) {
    var _iconProperty$iconCol, _iconProperty$iconSiz;
    var nameColorArr = [{
      type: 'info',
      name: 'info-filled',
      color: '#005697'
    }, {
      type: 'warning',
      name: 'info-filled',
      color: '#fed703'
    }, {
      type: 'success',
      name: 'check-filled',
      color: '#59B300'
    }, {
      type: 'error',
      name: 'alert_filled',
      color: '#ff0000'
    }];
    var obj = nameColorArr[0];
    var item = nameColorArr.find(function (k) {
      return k.type === type;
    });
    if (item !== undefined) {
      obj = item;
    }

    //class 默认值
    var classNameDefault = 'iron-alert-icon';
    if (iconProperty && iconProperty.iconClassName) {
      classNameDefault = classNames(classNameDefault, iconProperty.iconClassName);
    }
    return /*#__PURE__*/React.createElement(Icon, {
      name: obj.name,
      color: (_iconProperty$iconCol = iconProperty === null || iconProperty === void 0 ? void 0 : iconProperty.iconColor) !== null && _iconProperty$iconCol !== void 0 ? _iconProperty$iconCol : obj.color,
      size: (_iconProperty$iconSiz = iconProperty === null || iconProperty === void 0 ? void 0 : iconProperty.iconSize) !== null && _iconProperty$iconSiz !== void 0 ? _iconProperty$iconSiz : 20 //默认大小20
      ,
      className: classNameDefault
    });
  };
  return showAlert && /*#__PURE__*/React.createElement("div", {
    className: getContainerClassName(error, isToast, className),
    style: style
  }, icon !== null && icon !== void 0 ? icon : renderIcon(type, iconProperty), content && /*#__PURE__*/React.createElement("div", {
    className: "iron-alert-content",
    title: content
  }, content), isToast && /*#__PURE__*/React.createElement("div", {
    className: "iron-alert-close-icon iron-alert-flex",
    onClick: function onClick() {
      //通知父组件移除自身
      if (onRemove) {
        onRemove();
      }
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "cross",
    size: 20 //默认大小20
  })));
};
export default AlertItem;